$('.carousel-btn').click(function () {
    $('#carouselNavigation').on('slid.bs.carousel', function () {
        var text = $('#carouselNavigation .carousel-item.active').attr('id');

        if (text.indexOf('-') > -1) {
            var textT = text.substr(0, text.lastIndexOf("-"))
        }
    });
});

$('#carouselNavigation a').click(function () {
    var aid = $(this).attr("href").replace('#', '');
    var h2 = $('h2[id="' + aid + '"]');

    $('html,body').animate({
            scrollTop: $(h2).offset().top - 50
        },
        'slow', 'swing');
});

var headerH = $('header').outerHeight();
var carousel = $('#carouselNavigation');

if(carousel.length > 0){
    $(window).on('load scroll', function () {
        $('.header-top').css('top', carousel.outerHeight() + 'px');
        if ($(window).scrollTop() == 0) {
            // carousel.css('top', headerH + 'px');
            carousel.css('top', '46px');
            if (carousel.length > 0) {
                $('main > .container').css('padding-top', headerH + 'px');
            }
        } else {
            carousel.css('top', 0);
        }
    });
}
